"use strict";

import { Int64 } from "../types/int64";

export const rutil: any = {};

export function enumToName(list: any, val: any) {
    for (let i in list) {
        if (list.hasOwnProperty(i)) {
            if (list[i] === val) {
                return i;
            }
        }
    }
    return "unknown:" + val;
}
rutil.enumToName = enumToName;

export function debugValidateProps(obj: any, props: any) {
    for (let i = 0; i < props.length; ++i) {
        const propVal = (eval("obj." + props[i][0]) as any);
        if (propVal === undefined) {
            console.warn("Expected property to be set: ", props[i][0]);
            console.trace();
            continue;
        }
        if (propVal instanceof Int64) {
            // We can cheat since the check value has to be 32bit anyways.
            if (
                // @ts-ignore - propVal is Int64 instance
                propVal.hi !== 0 ||
                // @ts-ignore - propVal is Int64 instance
                (props[i][1] && propVal.lo < props[i][1]) ||
                // @ts-ignore - propVal is Int64 instance
                (props[i][2] && propVal.lo > props[i][2])
            ) {
                console.warn(
                    "Expected property",
                    props[i][0],
                    "to be between",
                    props[i][1],
                    "and",
                    props[i][2],
                    "(got:0x" + (propVal as any).toString(16) + ")",
                    obj
                );
                console.trace();
                continue;
            }
        } else {
            if (
                (props[i][1] && propVal < props[i][1]) ||
                (props[i][2] && propVal > props[i][2])
            ) {
                console.warn(
                    "Expected property",
                    props[i][0],
                    "to be between",
                    props[i][1],
                    "and",
                    props[i][2],
                    "(got:" + propVal + ")",
                    obj
                );
                console.trace();
                continue;
            }
        }
    }
}
rutil.debugValidateProps = debugValidateProps;

rutil.VIRTUAL_FUNC = function () {
    throw new Error("Pure virtual function was invoked");
};
